import Organisation from "@RequestFormV2/sections/Organisation/components/Organisation";
import Attachments from "@RequestFormV2/sections/Attachments/components/Attachments";
import PackingList from "@RequestFormV2/sections/PackingList/components/PackingList";
import Provider from "@RequestFormV2/sections/Provider/components/Provider";
import Schedule from "@RequestFormV2/sections/Schedule/components/Schedule";
import Service from "@RequestFormV2/sections/Service/components/Service";
import QuickService from "@RequestFormV2/sections/Service/components/QuickService";
import type { RequestFormMode } from "@RequestFormV2/context/requestFormMode";
import {
  QUICK_REQUEST_SECTION_DEFINITIONS,
  REQUEST_FORM_SECTION_DEFINITIONS,
  type RequestFormSectionDefinition,
} from "@RequestFormV2/sectionDefinitions";

export type { RequestFormSectionDefinition };

export interface RequestFormSection extends RequestFormSectionDefinition {
  component?: React.ComponentType;
}

const QUOTE_SECTION_COMPONENTS = [Organisation, Service, Schedule, PackingList, Provider];
const QUICK_SECTION_COMPONENTS = [Organisation, QuickService, Schedule, PackingList, Attachments];

export const REQUEST_FORM_SECTIONS: RequestFormSection[] = REQUEST_FORM_SECTION_DEFINITIONS.map((definition, index) => ({
  ...definition,
  component: QUOTE_SECTION_COMPONENTS[index],
}));

export const QUICK_REQUEST_SECTIONS: RequestFormSection[] = QUICK_REQUEST_SECTION_DEFINITIONS.map((definition, index) => ({
  ...definition,
  component: QUICK_SECTION_COMPONENTS[index],
}));

export function getRequestFormSections(mode: RequestFormMode): RequestFormSection[] {
  return mode === "quick" ? QUICK_REQUEST_SECTIONS : REQUEST_FORM_SECTIONS;
}
